import keycloak from '../keycloak';

const BASE = process.env.REACT_APP_API_BASE_URL || '/api';

async function request(path, options = {}) {
  await keycloak.updateToken(30);
  const res = await fetch(`${BASE}${path}`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${keycloak.token}`,
    },
    ...options,
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: res.statusText }));
    throw new Error(err.error || res.statusText);
  }
  if (res.status === 204) return null;
  return res.json();
}

export const api = {
  stores: {
    list: () => request('/stores'),
  },
  products: {
    list:   (store_id, type, category_id) => request(`/products?store_id=${store_id}${type ? `&type=${encodeURIComponent(type)}` : ''}${category_id ? `&category_id=${encodeURIComponent(category_id)}` : ''}`),
    get:    (id)             => request(`/products/${id}`),
    create: (data)           => request('/products', { method: 'POST', body: JSON.stringify(data) }),
    update: (id, data)       => request(`/products/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
    delete: (id)             => request(`/products/${id}`, { method: 'DELETE' }),
  },
  categories: {
    list:    (store_id) => request(`/categories?store_id=${store_id}`),
    get:     (id)       => request(`/categories/${id}`),
    create:  (data)     => request('/categories', { method: 'POST', body: JSON.stringify(data) }),
    update:  (id, data) => request(`/categories/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
    reorder: (items)    => request('/categories/reorder', { method: 'POST', body: JSON.stringify({ items }) }),
    delete:  (id)       => request(`/categories/${id}`, { method: 'DELETE' }),
  },
  media: {
    list:    (productId)      => request(`/media/${productId}`),
    create:  (productId, data) => request(`/media/${productId}`, { method: 'POST', body: JSON.stringify(data) }),
    update:  (id, data)       => request(`/media/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
    reorder: (productId, ids) => request(`/media/${productId}/order`, { method: 'PUT', body: JSON.stringify({ ids }) }),
    delete:  (id)             => request(`/media/${id}`, { method: 'DELETE' }),
  },
  categoryMedia: {
    list:    (categoryId)       => request(`/category-media/${categoryId}`),
    create:  (categoryId, data) => request(`/category-media/${categoryId}`, { method: 'POST', body: JSON.stringify(data) }),
    update:  (id, data)         => request(`/category-media/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
    reorder: (categoryId, ids)  => request(`/category-media/${categoryId}/order`, { method: 'PUT', body: JSON.stringify({ ids }) }),
    delete:  (id)               => request(`/category-media/${id}`, { method: 'DELETE' }),
  },
  meta: {
    productTypes: () => request('/meta/product-types'),
    units:        () => request('/meta/units'),
    properties:   () => request('/meta/properties'),
  },
};
